module.exports = "/images/laser tag (Union selection).svg?b87829ce29fa021a48084587bd110829";